<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
    :class="customStyle"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M12 6v12m6-6H6"
    />
  </svg>
</template>

<script>
export default {
  name: 'PlusIcon',

  props: {
    customStyle: {
      type: String,
      default: 'w-6 h-6',
    },
  },
}
</script>
